export class VeiculosCorridaModel {
  id_corrida: number;
  inicio: string;
  termino: string;
  km_inicio: string;
  km_termino: string;
  percurso: string;
  id_usuario: number;
  id_veiculo: number = null;
  outro_condutor: boolean;
  nome_outro_condutor: string;
  avarias: boolean;
  avarias_descricao: string;
}



// WEBPACK FOOTER //
// ./src/app/veiculos-corrida/veiculos-corrida.model.ts